import AppList from './AppList.vue';

export * from './types';
export default AppList;



// WEBPACK FOOTER //
// ./src/uikit/components/AppList/index.ts